import React, { useState } from 'react';
import { View } from 'react-native-web';
import LinkTextButton from './LinkTextButton';
import { add_hot_key_disabled } from '../../../utils/DictionaryManagementUtils';
import UploadContainer from '../Upload/UploadContainer';

//= ========================================================================

const AddDisabledMode = ({
  globJSON,
  onConfigChanged,
  object,
}) => {
  const [addDisabledMode, setAddDisabledMode] = useState(false);

  return (
    <View>
      {addDisabledMode
        ? (
          <UploadContainer
            globJSON={globJSON}
            onConfigChanged={onConfigChanged}
            listObject={object}
          />
        )
        : (
          <LinkTextButton onPress={setAddDisabledMode}>{add_hot_key_disabled}</LinkTextButton>
        )}
    </View>
  );
};
export default AddDisabledMode;
